import { render, staticRenderFns } from "./Pays.vue?vue&type=template&id=7e2505cb&scoped=true&"
import script from "./Pays.vue?vue&type=script&lang=js&"
export * from "./Pays.vue?vue&type=script&lang=js&"
import style0 from "@/styles/VerticalSwiper.sass?vue&type=style&index=0&id=7e2505cb&lang=sass&scoped=true&"
import style1 from "./Pays.vue?vue&type=style&index=1&id=7e2505cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2505cb",
  null
  
)

export default component.exports